module.exports = __webpack_public_path__ + "static/media/2026_WA-Footy-Lives-Here-Tile-Logged-In-@1x.6f6829a6.webp";